import React, { useState } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import CustomCodeDefault from './../../../editor/meta/highed.meta.customcode.default';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';

type CustomCodeProps = {
  customCodeStr: string | null;
  setCustomCode: (customCode: string) => void;
};

let customCodeTimeout: NodeJS.Timeout;

export default (props: CustomCodeProps) => {
  const [customCode, setCustomCode] = useState(props.customCodeStr || CustomCodeDefault.join('\n'));

  const settings = {
    theme: 'monokai',
    mode: 'javascript',
    lineNumbers: true
  };

  const onChange = (editor: CodeMirror.Editor, data: CodeMirror.EditorChange, value: string) => {
    if (customCodeTimeout) {
      clearTimeout(customCodeTimeout);
    }

    customCodeTimeout = setTimeout(() => {
      props.setCustomCode(value);
    }, 1000);
  };

  const onBeforeChange = (editor: CodeMirror.Editor, data: CodeMirror.EditorChange, value: string) => {
    setCustomCode(value);
  };

  return (
    <div className={'custom-code-container'} style={{ width: 332 }}>
      <CodeMirror
        options={settings}
        value={customCode}
        onBeforeChange={onBeforeChange}
        onChange={onChange}
        className={'h-[calc(100vh-315px)]'}
      />
    </div>
  );
};
